/* Header transparent → solide collé au scroll (accueil) + ouverture des
   sous-menus du header au survol (desktop, sur TOUTES les pages).
   Additif, sans dépendance. */
(function () {
  var body = document.body;

  /* --- Sous-menus du header AU SURVOL (desktop) — sur TOUTES les pages ---
     On pose l'attribut [open] natif au survol : c'est le chemin de Dawn,
     qui gère correctement l'empilement (le panneau passe au premier plan).
     Un léger délai à la fermeture évite tout clignotement.

     27/09/2026 : ce survol s'appliquait a TOUS les <details> du menu, donc aussi aux familles
     de produits ajoutees dans le panneau (« Geschenke zur Geburt », « Groß werden »…). En glissant
     la souris vers un produit, on traversait la famille voisine, qui s'ouvrait, ce qui poussait
     la liste et faisait fuir le lien vise. Malo : « si je glisse mon curseur un peu trop, ca
     ouvre l'autre, ca fait un truc degueulasse. Faut cliquer pour que la sous-section s'ouvre. »

     Le survol ne vaut donc plus que pour le PREMIER niveau, celui qui ouvre le panneau. Les
     familles a l'interieur s'ouvrent au clic sur leur « + », et plusieurs peuvent rester
     ouvertes en meme temps : c'est le comportement natif de <details>, on ne le contrarie pas. */
  function initHoverMenus() {
    if (!window.matchMedia('(hover: hover) and (min-width: 990px)').matches) return;
    /* Le premier niveau est enveloppe dans <header-menu>, pas directement dans le <li> :
       on prend donc tous les <details> du menu SAUF ceux imbriques dans un autre <details>. */
    var tous = document.querySelectorAll('.header__inline-menu details');
    Array.prototype.filter.call(tous, function (d) {
      return !d.parentElement.closest('details');
    }).forEach(function (d) {
      if (d.dataset.cpHover === '1') return;
      d.dataset.cpHover = '1';
      var t;
      d.addEventListener('mouseenter', function () {
        clearTimeout(t);
        d.setAttribute('open', '');
      });
      d.addEventListener('mouseleave', function () {
        t = setTimeout(function () { d.removeAttribute('open'); }, 150);
      });
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initHoverMenus);
  } else {
    initHoverMenus();
  }
  window.addEventListener('load', initHoverMenus);

  /* --- Header transparent → solide au scroll : ACCUEIL uniquement ---
     Le header est en position:fixed sous le bandeau d'annonce ; au scroll il
     remonte à top:0 et passe en crème solide (classe body .cp-scrolled). */
  if (!body.classList.contains('cp-transparent-header')) return;

  function annHeight() {
    var ann = document.querySelector('.utility-bar, .announcement-bar, .announcement-bar-section');
    return ann ? ann.offsetHeight : 0;
  }

  function setVars() {
    document.documentElement.style.setProperty('--cp-ann-h', annHeight() + 'px');
  }

  function onScroll() {
    var threshold = Math.max(annHeight() - 4, 10);
    if (window.scrollY > threshold) body.classList.add('cp-scrolled');
    else body.classList.remove('cp-scrolled');
  }

  function init() { setVars(); onScroll(); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', function () { setVars(); onScroll(); }, { passive: true });
  window.addEventListener('load', setVars);
})();

/* ============================================================
   Apparition douce des sections au scroll (TOUTES pages), façon premium.
   Sécurisé : si le JS ne tourne pas, RIEN n'est masqué (le style n'est posé
   que par JS, sans !important). Respecte prefers-reduced-motion. Exclut les
   barres fixes / sections sans hauteur, et les sections au-dessus de la ligne
   de flottaison (affichées immédiatement). Déclenchement un peu anticipé pour
   éviter tout blanc au scroll, + filet de sécurité au load.
   ============================================================ */
(function () {
  if (!('IntersectionObserver' in window)) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var style = document.createElement('style');
  style.textContent =
    '.cp-reveal{opacity:0;transform:translateY(16px);transition:opacity .7s ease,transform .7s ease;}' +
    '.cp-reveal.cp-in{opacity:1;transform:none;}';
  document.head.appendChild(style);

  function setup() {
    var vh = window.innerHeight || document.documentElement.clientHeight;
    var io = new IntersectionObserver(function (entries, obs) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('cp-in'); obs.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px 12% 0px', threshold: 0 });

    var observed = [];
    document.querySelectorAll('#MainContent > .shopify-section').forEach(function (el) {
      var r = el.getBoundingClientRect();
      if (r.height < 40) return;
      if (r.top <= vh * 0.92) return;
      el.classList.add('cp-reveal');
      io.observe(el);
      observed.push(el);
    });

    /* Filet de sécurité : au load, révèle ce qui serait déjà à l'écran. */
    window.addEventListener('load', function () {
      observed.forEach(function (el) {
        if (el.getBoundingClientRect().top < (window.innerHeight || 0)) {
          el.classList.add('cp-in');
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setup);
  } else {
    setup();
  }
})();
